/**
 * Icon and English label per Razorpay `payment_method_types` id; keep in sync with the API.
 *
 * Plain JS with no imports and no optional chaining: blocks-next imports it untransformed and
 * its build rejects `@wordpress/i18n`. Translation happens in functions/razorpay.ts.
 */
export const RAZORPAY_METHOD_META = {
  card: { icon: 'razorpay', label: 'Credit Card' },
  upi: { icon: 'upi', label: 'UPI' },
};

/** English (untranslated) label for a Razorpay method id. Returns `undefined` for unknown ids. */
export const getRazorpayMethodLabel = (type) => (type && RAZORPAY_METHOD_META[type] ? RAZORPAY_METHOD_META[type].label : undefined);

/** `sc-icon` name for a Razorpay method id. Falls back to the branded razorpay icon. */
export const getRazorpayMethodIcon = (type) => (type && RAZORPAY_METHOD_META[type] && RAZORPAY_METHOD_META[type].icon) || 'razorpay';
